import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-031c194d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-content" }
const _hoisted_2 = { id: "mountNode" }
const _hoisted_3 = { class: "drawer-content" }
const _hoisted_4 = {
  key: 0,
  class: "list-content"
}
const _hoisted_5 = { class: "selected-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关联促销政策商品清单", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_9 = { style: {"height":"calc(100% - 196px)"} }
const _hoisted_10 = { class: "drawer-content" }
const _hoisted_11 = { class: "selected-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关联特殊折扣商品清单", -1))
const _hoisted_13 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_OioTextarea = _resolveComponent("OioTextarea")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_OioDateTimePicker = _resolveComponent("OioDateTimePicker")!
  const _component_oio_col = _resolveComponent("oio-col")!
  const _component_oio_row = _resolveComponent("oio-row")!
  const _component_OioForm = _resolveComponent("OioForm")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_oio_switch = _resolveComponent("oio-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(['iconfont', _ctx.isFullScreen ? 'icon-tuichuquanping' : 'icon-quanping']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFullScreen = !_ctx.isFullScreen))
      }, null, 2)
    ]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      getContainer: "#mountNode",
      visible: _ctx.showLinkModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showLinkModal) = $event)),
      title: "关联商品清单",
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showLinkList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.selectedLinkName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLinkName) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showLinkList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "list-item",
                        key: index
                      }, [
                        _createVNode(_component_a_radio, {
                          value: item.merchBillName,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.merchBillName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.selectedLinkName || '暂无数据'), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      getContainer: "#mountNode",
      visible: _ctx.showPolicyModal,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showPolicyModal) = $event)),
      title: "促销政策配置",
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_oio_form, {
          ref: "policyFormRef",
          data: _ctx.activeNode.jsonData.policyInfo
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oio_form_item, {
              name: "name",
              label: "政策名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  disabled: "",
                  value: _ctx.activeNode.jsonData.name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeNode.jsonData.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "policyThemes",
              label: "政策主题",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  disabled: "",
                  value: _ctx.activeNode.jsonData.policyInfo.policyThemes,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.policyThemes) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "policyLabel",
              label: "政策标签",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  disabled: "",
                  value: _ctx.activeNode.jsonData.policyInfo.policyLabel,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.policyLabel) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "accountTimeRule",
              label: "记账时间规则",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  disabled: "",
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  value: _ctx.activeNode.jsonData.policyInfo.accountTimeRule,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.accountTimeRule) = $event)),
                  placeholder: "请按需选择指定记账时间",
                  defaultActiveFirstOption: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "DELIVERY_TIME" }, {
                      default: _withCtx(() => [
                        _createTextVNode("按发货时间记账")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "TARGET_TIME" }, {
                      default: _withCtx(() => [
                        _createTextVNode("按指定时间记账")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.activeNode.jsonData.policyInfo.accountTimeRule === 'DELIVERY_TIME')
              ? (_openBlock(), _createBlock(_component_oio_form_item, {
                  key: 0,
                  name: "paymentDays",
                  label: "指定账期天数",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_input, {
                      disabled: "",
                      value: _ctx.activeNode.jsonData.policyInfo.paymentDays,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.paymentDays) = $event)),
                      placeholder: "请按需录入指定账期天数"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.activeNode.jsonData.policyInfo.accountTimeRule === 'TARGET_TIME')
              ? (_openBlock(), _createBlock(_component_oio_form_item, {
                  key: 1,
                  name: "accountDate",
                  label: "指定账期时间",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OioDateTimePicker, {
                      disabled: "",
                      value: _ctx.activeNode.jsonData.policyInfo.accountDate,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.accountDate) = $event)),
                      placeholder: "请按需录入指定账期时间"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_oio_form_item, {
              name: "promotionType",
              label: "促销类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  value: _ctx.activeNode.jsonData.policyInfo.promotionType,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.promotionType) = $event)),
                  placeholder: "请选择促销类型",
                  allowClear: "",
                  defaultActiveFirstOption: false,
                  options: _ctx.baseData.promotionTypeEnumList,
                  disabled: true
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "让利归属" }, {
              default: _withCtx(() => [
                _createVNode(_component_OioForm, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_row, { gutter: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_form_item, {
                              name: "platformDiscount",
                              label: "总部",
                              labelAlign: "LEFT"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oio_input, {
                                  value: _ctx.activeNode.jsonData.policyInfo.platformDiscount,
                                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.platformDiscount) = $event)),
                                  placeholder: "",
                                  suffix: "%",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_oio_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_form_item, {
                              name: "provinceDiscount",
                              label: "省区",
                              labelAlign: "LEFT"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oio_input, {
                                  value: _ctx.activeNode.jsonData.policyInfo.provinceDiscount,
                                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.provinceDiscount) = $event)),
                                  placeholder: "",
                                  suffix: "%",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_oio_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_form_item, {
                              name: "productDiscount",
                              label: "产品公司",
                              labelAlign: "LEFT"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oio_input, {
                                  value: _ctx.activeNode.jsonData.policyInfo.productDiscount,
                                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.activeNode.jsonData.policyInfo.productDiscount) = $event)),
                                  placeholder: "",
                                  suffix: "%",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      getContainer: "#mountNode",
      visible: _ctx.showRightsSettingModal,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showRightsSettingModal) = $event)),
      title: "权益信息配置",
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_oio_form, {
            ref: "rightsSettingsFormRef",
            data: _ctx.activeNode.jsonData.equityInformationRule,
            layout: "horizontal",
            "label-col": { span: 10 },
            "wrapper-col": { span: 14 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_form_item, {
                name: "name",
                label: "权益名称",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OioTextarea, {
                    rows: 3,
                    disabled: "",
                    value: _ctx.activeNode.jsonData.equityInformationRule.name,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeNode.jsonData.equityInformationRule.name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (_ctx.showRealPrice)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 0,
                    name: "realPriceNotBenefits",
                    label: "实价产品不让利"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        disabled: "",
                        checked: _ctx.activeNode.jsonData.equityInformationRule.realPriceNotBenefits,
                        "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activeNode.jsonData.equityInformationRule.realPriceNotBenefits) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showOnePrice)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 1,
                    name: "buyItNotBenefits",
                    label: "一口价产品不让利"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        disabled: "",
                        checked: _ctx.activeNode.jsonData.equityInformationRule.buyItNotBenefits,
                        "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.activeNode.jsonData.equityInformationRule.buyItNotBenefits) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showAdvanceSetting)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 2,
                    name: "isAdvanced",
                    label: "高级配置"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        disabled: "",
                        checked: _ctx.activeNode.jsonData.equityInformationRule.isAdvanced,
                        "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.activeNode.jsonData.equityInformationRule.isAdvanced) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.activeNode.jsonData.equityInformationRule.advanceItemStr || '暂无数据'), 1)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.activeNode.jsonData.equityInformationRule.isAdvanced]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}